import { render, staticRenderFns } from "./dataV_B.vue?vue&type=template&id=6a734e2c&scoped=true&"
import script from "./dataV_B.vue?vue&type=script&lang=js&"
export * from "./dataV_B.vue?vue&type=script&lang=js&"
import style0 from "./dataV_B.vue?vue&type=style&index=0&id=6a734e2c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a734e2c",
  null
  
)

export default component.exports